import { ReducerCreators } from '@reduxjs/toolkit';
import { AudiencesState } from '../types';

export const setAllAttendeesPageSize = (create: ReducerCreators<AudiencesState>) =>
  create.reducer<AudiencesState['allAttendees']['pageSize']>((state, action) => {
    state.allAttendees.pageSize = action.payload;
    state.allAttendees.page = 1;
  });
